import { Outlet } from 'react-router-dom';
import { Container, Center } from '@chakra-ui/react';
import { Toaster } from '@/components/ui/toaster';

export default function AuthLayout() {
  return (
    <Center minH={'100vh'}>
      <Container maxW={'md'} px={{ base: 4, md: '6', lg: '8' }}>
        <Outlet />
        <Toaster />
      </Container>
    </Center>
  );
}
